export function initZendesk() {
  if (window.self === window.top) {
    if (!window.$zopim) {
      window.$zopim = {
        livechat: {
          setOnUnreadMsgs: function () {},
          setOnStatus: function () {},
          window: {
            show: function () {},
            hide: function () {},
            toggle: function () {},
          },
        },
      };
    }

    window.zESettings = {
      webWidget: {
        zIndex: 1000,
        launcher: {
          hide: true, // Hide native launcher, we use a custom button
        },
      },
    };

    ['mousemove', 'touchmove'].forEach(event =>
      window.addEventListener(
        event,
        function () {
          const script = document.createElement('script');
          script.id = 'ze-snippet';
          script.src =
            'https://static.zdassets.com/ekr/snippet.js?key=ea900a10-2371-4169-a7d8-927253810bef';

          // Hide the widget launcher once the script is loaded
          script.onload = () => {
            const action = document.documentElement.classList.contains(
              'page--configurator'
            )
              ? 'hide'
              : 'show';
            globalThis.zE?.('webWidget', action);
          };

          document.head.appendChild(script);
        },
        { once: true }
      )
    );
  }
}
